import {
  Box,
  Grid,
  Select,
  MenuItem,
  Container,
  Typography,
  InputLabel,
  FormControl,
} from "@mui/material";
import React from "react";
import {
  Task,
  Lock,
  Group,
  Place,
  Bungalow,
  Apartment,
  LocalPhone,
  Accessible,
  MailOutline,
  LocalParking,
  ManageAccounts,
  DriveFileRenameOutline,
  KeyboardArrowDownOutlined,
  AddPhotoAlternateOutlined,
} from "@mui/icons-material";


import HeadingText from "./HeadingText";

function Confirmation({ register, errors, watch, setValue }) {
  
  return (
    <Container maxWidth="md">
      <Container maxWidth="md">
        <Grid container>
          <Grid item xs={12} sm={5}>

          <HeadingText
              main="Personal Information"
              sub="Input all the required information to continue."
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <DriveFileRenameOutline
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Name"
                style={{ marginTop: 20 }}
                {...register("name")}
                disabled
              />
              <p className="error">{errors.name?.message}</p>
            </Box>

            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <MailOutline
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Email"
                style={{ marginTop: 20 }}
                {...register("mail")}
                disabled
              />
              <p className="error">{errors.mail?.message}</p>
            </Box>

            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <LocalPhone
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Phone Number <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Phone Number"
                style={{ marginTop: 20 }}
                {...register("phone")}
                disabled
              />
              <p className="error">{errors.phone?.message}</p>
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={5}>
            <HeadingText main="Enter Password" sub="Enter a secret password." />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <Lock
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Password <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="password"
                placeholder="Enter Password"
                style={{ marginTop: 20 }}

                {...register("pass")}
                disabled
              />
              <p className="error">{errors.pass?.message}</p>
            </Box>

            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <Lock
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Retype  Password <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="password"
                placeholder="Retype Password"
                style={{ marginTop: 20 }}

                {...register("rePass")}
                disabled
              />
              <p className="error">{errors.rePass?.message}</p>
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} sm={5}>
            <HeadingText
              main="Property Role"
              sub="Select the role you play at this complex."
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "20px" }}>
              <ManageAccounts
                color="primary"
                sx={{ position: "absolute", top: "25px", left: "12px" }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Complex Role
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Complex Role"
                style={{ marginTop: 20 }}
                {...register("role")}
                disabled
                
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth={"md"}>
        <Grid container>
          <Grid item xs={12} sm={5}>
            <HeadingText
              main="Complex Information"
              sub="Input all the required information to continue."
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <DriveFileRenameOutline
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Complex Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Complex Name"
                style={{ marginTop: 20 }}

                {...register("comName")}
                disabled
              />
              <p className="error">{errors.comName?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Place
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Complex Address <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Complex Address"
                style={{ marginTop: 20 }}

                {...register("comAddress")}
                disabled
              />
              <p className="error">{errors.comAddress?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Apartment
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Number of Units <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Number of Units"
                style={{ marginTop: 20 }}
                {...register("comUnit")}
                disabled
              />
              <p className="error">{errors.comUnit?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <MailOutline
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Complex Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Complex Email"
                style={{ marginTop: 20 }}
                {...register("comMail")}
                disabled
              />
              <p className="error">{errors.comMail?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <LocalPhone
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />

              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Complex Phone Number
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Enter Complex Phone Number"
                style={{ marginTop: 20 }}
                {...register("comPhone")}
                disabled
              />
            </Box>
            <Box sx={{ marginBottom: "48px" }}>
              <FormControl fullWidth size="small" focused>
                <InputLabel id="demo-simple-select-label" sx={{ left: -5, top: -10, }}>
                  Gated or Open Complex
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Gated or Open Complex"
                  {...register("gate")}
                  value={watch("gate")}
                  onChange={(e) => setValue("gate", e.target.value)}
                  color="primary"
                  IconComponent={KeyboardArrowDownOutlined}
                  autoFocus
                  sx={{
                    color: "#186FE7",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                  }}
                  startAdornment={
                    <LocalParking
                      sx={{
                        backgroundColor: "#186fe7",
                        color: "#fff",
                        borderRadius: "3px",
                        scale: "0.8",
                      }}
                    />
                  }
                >
                  <MenuItem disabled value={""}>
                    <>Selected Gated or Open Complex</>
                  </MenuItem>
                  <MenuItem value={"Gated Complex"}>Gated Complex</MenuItem>
                  <MenuItem value={"Open Complex"}>Open Complex</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} sm={5}>
            <HeadingText
              main="Upload Images of Complex"
              sub="Upload the most relevant images of the complex for guests and tenants to easily identify the property."
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Box
                component="label"
                sx={{
                  backgroundColor: "#fff",
                  textAlign: "center",
                  display: "block",
                  position: "relative",
                  border: watch("fileName")
                    ? "1px solid #186FE7"
                    : "1px dashed #186FE7",
                  borderRadius: "8px",
                  width: "100%",
                  padding: watch("fileName") ? "8px 8px 8px 48px" : "20px",
                  "&:hover": { backgroundColor: "#f9f9f9" },
                }}
              >
                <label style={{ position: "absolute", left: 10, top: -20, color: "#186FE7", fontSize: 14 }}>
                  Complex Image
                </label>
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(e) =>
                    setValue("fileName", e.target.files?.[0]?.name || "")
                  }
                />

                {watch("fileName") ? (
                  <Box>
                    <Task
                      sx={{
                        color: "#186FE7",
                        position: "absolute",
                        top: "25px",
                        left: "12px",
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Arimo",
                        color: "#186FE7",
                        textAlign: "left",
                      }}
                    >
                      {watch("fileName")}
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <AddPhotoAlternateOutlined
                      color="primary"
                      fontSize="large"
                    />
                    <Typography sx={{ fontFamily: "Arimo", color: "#186FE7" }}>
                      Drop or click to upload your image here
                      <span sx={{ fontSize: "10px" }}>Supports JPEG, PNG</span>
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md">
        <Grid container>
          <Grid item xs={12} sm={5}>
            <HeadingText
              main="Parking Information"
              sub="Input all the required information to continue."
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <LocalParking
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Parking Spots<span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Number of Parking Spots"
                style={{ marginTop: 20 }}
                {...register("pSpot")}
                disabled
              />
              <p className="error">{errors.pSpot?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <LocalParking
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                  backgroundColor: "#186fe7",
                  color: "#fff",
                  borderRadius: "3px",
                  scale: "0.8",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Tenants Parking <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Number of Parking Spaces Designated to Tenants (each)"
                style={{ marginTop: 20 }}
                {...register("pNumber")}
                disabled
              />
              <p className="error">{errors.pNumber?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Group
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Guest Parking <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Number of Guest Parking"
                style={{ marginTop: 20 }}
                {...register("pNumGuest")}
                disabled
              />
              <p className="error">{errors.pNumGuest?.message}</p>
            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Bungalow
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Administration Parking
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Number of Administration Parking"
                style={{ marginTop: 20 }}
                {...register("pAdmin")}
                disabled
              />
              <p className="error">{errors.pAdmin?.message}</p>

            </Box>
            <Box sx={{ position: "relative", marginBottom: "48px" }}>
              <Accessible
                color="primary"
                sx={{
                  position: "absolute",
                  top: "25px",
                  left: "12px",
                }}
              />
              <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
                Handicap Parking
              </label>
              <input
                className="text_input"
                type="text"
                placeholder="Number of Handicap Parking"
                style={{ marginTop: 20 }}
                {...register("pHandcap")}
                disabled
              />
              <p className="error">{errors.pHandcap?.message}</p>

            </Box>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
}

export default Confirmation;
